module.exports = __webpack_public_path__ + "img/service4.75136c55.png";